<template>
  <div class="fill-height"
    :style="[
      {'background-image': `url('${require('@/assets/background-login.jpg')}')`},
      {'background-repeat': 'repeat'}
    ]"
  >
    <strategio-app-bar></strategio-app-bar>
    <v-content style="height:100vh">
      <div style="max-height:100%; overflow:auto">
        <user-form 
          :user-data="user" 
          is-my-account 
          parent-route="/" 
          back-button-text="Pagina principal"
        ></user-form>
      </div>

    </v-content>
  </div>
</template>

<script>
import StrategioAppBar from '../components/header-bar/strategio-app-bar.vue'
import UserForm from '../components/users/user-form'
import userStorage from '../storage/userStorage'

export default {
  name: 'user-account',
  data () {
    return {
      user: userStorage.getUserInfo()
    }
  },
  components: {
    StrategioAppBar,
    UserForm
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/routes/user-account.vue